<template>
  <div class="wel-page">
    <div class="wel-page_title1">
      <img src="../../assets/img/pc/wel_title-1.png" alt="" />
    </div>
    <div class="wel-page_title2">
      <img src="../../assets/img/pc/wel_title-2.png" alt="" />
    </div>
    <div class="wel-page_title3">
      <img src="../../assets/img/pc/wel_title-3.png" alt="" />
    </div>
    <div class="wel-page_title4">
      <img src="../../assets/img/pc/wel_title-4.png" alt="" />
    </div>
    <div class="wel-page_button" @click="clickButton">
      <img src="../../assets/img/pc/wel_button.png" alt="" />
    </div>
    <div class="wel-page_bottom">
      中共思明区委宣传部<br />
      厦门市思明区社会科学界联合会
      <div class="wel-page_bottom_other">联合出品</div>
      <!-- 中共思明区委宣传部 出品 -->
      <div class="wel-page_bottom_footer">
        所有历史素材均由中共思明区委宣传部提供
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    clickButton() {
      this.$emit('welEnter')
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
.wel-page {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('../../assets/img/pc/wel-bg.png') #9c2b33 no-repeat center
    center/100% 100%;
  .wel-page_title1 {
    width: rem(210);
    position: absolute;
    top: rem(80);
    right: rem(64);
    img {
      display: block;
      width: 100%;
    }
  }
  .wel-page_title2 {
    width: rem(740);
    position: absolute;
    top: rem(140);
    left: rem(140);
    img {
      display: block;
      width: 100%;
    }
  }
  .wel-page_title3 {
    width: rem(608);
    position: absolute;
    top: rem(374);
    left: rem(140);
    img {
      display: block;
      width: 100%;
    }
  }
  .wel-page_title4 {
    width: rem(720);
    position: absolute;
    top: rem(500);
    left: rem(140);
    img {
      display: block;
      width: 100%;
    }
  }
  .wel-page_button {
    cursor: pointer;
    width: rem(290);
    position: absolute;
    top: rem(700);
    left: rem(354);
    img {
      display: block;
      width: 100%;
    }
  }
  .wel-page_bottom {
    position: absolute;
    bottom: rem(50);
    left: 50%;
    transform: translateX(-50%);
    // width: rem(120);
    text-align: center;
    font-size: rem(20);
    color: rgba(255, 240, 198, 1);
    line-height: rem(40);
    letter-spacing: 1.4px;
  }
  .wel-page_bottom_other {
    position: absolute;
    right: rem(-110);
    top: 50%;
    transform: translateY(-50%);
  }
  .wel-page_bottom_footer {
    font-size: rem(16);
    position: absolute;
    right: rem(-830);
    bottom: 0;
  }
}
</style>
